import '../www/css/index.css';
import { Capacitor } from '@capacitor/core';
import config from 'config';
import app from 'lib/app';
import setup from 'lib/setup';
import capacitorReady from 'lib/capacitor-init';
import { registerServiceWorker } from 'lib/sw-updates';
import swBuildId from 'virtual:sw-build-id';

window.app = app;
setup( app );


function bootstrapApp()
{
	$(function()
	{
		if( config.debug )
		{
			window.onerror = function( error )
			{
				console.error( error )

				$("#error-text").html( error.stack ? error.stack : error )
				$("#error-modal").modal().on('hidden.bs.modal')
			}

		}

		if( config.logging )
		{
			$("#debug-toolbar").removeClass('d-none');
			_.each( app.status, function( ok, status )
			{
				$("#debug-status-"+status).toggleClass('fas',ok).toggleClass('far',!ok);
			});
			app.on( 'status', function( status, ok )
			{
				$("#debug-status-"+status).toggleClass('fas',ok).toggleClass('far',!ok);
			});


			$("#debug-log").removeClass('d-none');

			var type_list = { log: 'dark', info: 'dark', warn: 'warning', error: 'danger' };
			app.on('log', function( args, type )
			{
				var style = _.has( type_list, type ) ? type_list[type] : 'dark';
				var li = $('<li/>',{class:'text-'+style}).appendTo("#debug-log-list").append( $( '<span/>', {class: 'text-muted pr-2' } ).text( (new Date).toJSON().substr(11,8) ) );
				_.each( args, function( text ) { li.append( $('<span/>', { class: 'pr-2' }).text( text ) ) } );
			});
		}


		app.on( 'ready', function()
		{
			$("#app-wrapper").html('');
			$("#app-header").removeClass('d-none');
			$("#app-footer").removeClass('d-none');
			$("#app-progress-bar").toggleClass('bg-dark bg-success');
		}),

		app.on( 'progress', function( progress )
		{
			var loaded = _.reduce( _.filter( _.pluck( progress, 'loaded' ) ), function( m, v ) { return m + v } );
			var total  = _.reduce( _.filter( _.pluck( progress, 'total'  ) ), function( m, v ) { return m + v } );

			$("#app-progress").toggleClass( 'd-none', !total );
			if( total )
			{
				$("#app-progress-bar").css( 'width', ( 100 * loaded / total ) + '%' );
			}
		});

		app.on( 'message', function( message )
		{
			$("#app-message").append( $(message).show() );
		});

		app.initialize( config );

		if( !Capacitor.isNativePlatform() )
		{
			registerServiceWorker( swBuildId, function()
			{
				console.log( 'SW_SYNC reçu, lancement de la synchronisation' );
				app.requestSync( { reason: 'sw-sync' } );
			} );
		}
	});
}


capacitorReady.then( bootstrapApp );


$.fn.serializeJSON = function()
{
	var json = {};

	this.find(':input').not(':file').map(function(){return $(this).attr('name')}).each( function( n, name )
	{
		json[ name.replace( /\[.*\]$/, '' ) ] = null
	})

	var data = this.serializeArray();
	var int = /^([1-9]\d*|0)$/;

	_.each( data, function( p )
	{
		var value = int.test( p.value ) ? parseInt( p.value ) : p.value;
		if( value == "" ) value = null;


		if( p.name.substr(-2) == '[]' )
		{
			var name = p.name.substr(0,p.name.length - 2);
			if( _.isEmpty( json[ name ] ) ) json[ name ] = [];
			json[ name ].push( value );
		}
		else
		{
			json[ p.name ] = value;
		}
	});

	return json;
}
